import { MATCH_STATUS } from "../constants";
import { IStatus } from "../interface";

export function isLiveMatch(status: IStatus) {
    return status.id === MATCH_STATUS.LIVE || status.id === MATCH_STATUS.HT
}

export function isSoccerPage() {
    return /\/bong\-da|\/soccer/i.test((window as any).location.pathname);
}